module.exports = __webpack_public_path__ + "static/media/LogoWhite.63cb4e7f.svg";